import React, { Component } from 'react'
import { Row, Icon, Button } from 'antd'
import { hmoCost } from '@services/api'
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.state = { newPrices: [{ age_to: 120, age_from: 0, price: 0 }] }
    }

    handleUpdate = (idx, key, value) => {
        let newPrices = [...this.state.newPrices]
        newPrices[idx][key] = +value
        this.setState({ newPrices })
    }

    render() {
        const { newPrices } = this.state
        const {
            authStore: { fullName },
            policyId,
            update,
            setNewAges
        } = this.props
        let marginRight = { marginRight: 20 }
        let inputStyle = { marginRight: 8, width: 80 }
        let disabled = newPrices.filter(price => price.age_from >= price.age_to).length

        return (
            <>
                {newPrices.map((ageRange, idx) => {
                    const { age_to, age_from, price } = ageRange
                    return (
                        <Row key={idx} gutter={28}>
                            <span style={marginRight}>גיל מינימלי: {age_from} </span>
                            <span style={marginRight}>
                                גיל מקסימלי:
                                <input
                                    type="number"
                                    style={{ ...inputStyle, backgroundColor: age_from >= age_to ? 'red' : undefined }}
                                    value={age_to}
                                    onChange={e => this.handleUpdate(idx, 'age_to', e.target.value)}
                                    disabled={idx + 1 < newPrices.length}
                                />
                            </span>
                            <span style={marginRight}>
                                מחיר:
                                <input
                                    type="number"
                                    style={inputStyle}
                                    value={price}
                                    onChange={e => this.handleUpdate(idx, 'price', e.target.value)}
                                />
                            </span>
                            {idx != 0 && idx + 1 == newPrices.length && (
                                <Icon
                                    style={marginRight}
                                    type="delete"
                                    onClick={() =>
                                        this.setState({
                                            newPrices: newPrices.filter((it, idx) => idx + 1 < newPrices.length)
                                        })
                                    }
                                />
                            )}
                        </Row>
                    )
                })}
                <Button
                    onClick={() =>
                        this.setState({
                            newPrices: [
                                ...newPrices,
                                {
                                    age_to: newPrices[newPrices.length - 1].age_to + 1,
                                    age_from: newPrices[newPrices.length - 1].age_to,
                                    price: 0
                                }
                            ]
                        })
                    }
                    disabled={disabled}
                >
                    <Icon type="plus" />
                </Button>
                <Button
                    disabled={disabled}
                    style={marginRight}
                    onClick={async () => {
                        await setNewAges({ ...this.state, policyId, updated_by: fullName })
                        update()
                    }}
                >
                    <Icon type="check" />
                </Button>
            </>
        )
    }
}
